import { restResourceRequester } from "../rest-resource-requester";
import {
  createAuthorizationRequester,
  AuthorizationRestResource,
} from "@vrf/fr-vrf-auth-core";

export const authorizationRestResource: AuthorizationRestResource =
  createAuthorizationRequester(restResourceRequester);
